module.exports = __webpack_public_path__ + "static/media/commonWebsite.af7c735f.svg";